import axios from 'axios';
import Vue from 'vue';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Request interceptor
axios.interceptors.request.use(
  (config) => {
    config.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute('content'),
    };

    return config;
  },
  (error) => {
    console.error(error);

    return Promise.reject(error);
  }
);

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;

    if (status === 401) {
      Vue.dialog
        .alert("We're sorry, you don't appear to be authorised to access this.")
        .then(function (dialog) {
          dialog.close();
        });
    }

    if (status === 403) {
      Vue.dialog
        .alert(
          "We're sorry, you don't appear to be authorised to perform this action."
        )
        .then(function (dialog) {
          dialog.close();
        });
    }

    if (status === 419) {
      Vue.dialog
        .alert(
          "We're sorry, you session has expired. Please refresh the page and try again."
        )
        .then(function (dialog) {
          dialog.close();
        });
    }

    if (status >= 500) {
      Vue.dialog
        .alert(
          "We're sorry, there appears to have been a problem trying to access the data."
        )
        .then(function (dialog) {
          dialog.close();
        });
    }

    return Promise.reject(error);
  }
);

export default axios;
